"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const path_1 = require("path");
const minimatch = require("minimatch");
function getDefaults(globals) {
    const processCwd = process.cwd();
    const jsLoaders = [];
    const tsLoaders = [];
    if (globals.babel !== false) {
        const babelLoader = {
            loader: require.resolve('babel-loader'),
            options: globals.babel
        };
        tsLoaders.push(babelLoader);
        jsLoaders.push(babelLoader);
    }
    if (globals.typescript !== false) {
        tsLoaders.push({
            loader: require.resolve('ts-loader'),
            options: {
                compilerOptions: globals.typescript
            }
        });
    }
    return {
        clean: true,
        cache: true,
        context: processCwd,
        entry: './src',
        output: {
            path: path_1.join(processCwd, 'dist'),
            filename: 'index.js',
            libraryTarget: 'commonjs'
        },
        target: 'node',
        devtool: 'source-map',
        node: {
            console: false,
            global: false,
            process: false,
            Buffer: false,
            __filename: false,
            __dirname: false
        },
        plugins: [],
        resolve: {
            extensions: ['.js', '.ts', '.tsx']
        },
        resolveLoader: {
            modules: [
                'node_modules/urbanjs-tools/node_modules',
                'node_modules'
            ]
        },
        externals: [
            (context, request, callback) => {
                const isSourceFile = path_1.isAbsolute(request) || /^\..+/.test(request);
                callback(null, !isSourceFile);
            }
        ],
        module: {
            rules: [
                {
                    test: /\.tsx?$/,
                    exclude: (filePath) => globals.ignoredSourceFiles.some(glob => minimatch(filePath, glob)),
                    use: tsLoaders
                },
                {
                    test: /\.js$/,
                    exclude: (filePath) => globals.ignoredSourceFiles.some(glob => minimatch(filePath, glob)),
                    use: jsLoaders
                }
            ]
        }
    };
}
exports.getDefaults = getDefaults;
